import React from 'react';
import { Box, Typography, Stack, IconButton, Divider } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

const socials = [
  { icon: <TwitterIcon />, label: 'Twitter' },
  { icon: <YouTubeIcon />, label: 'YouTube' },
  { icon: <GitHubIcon />, label: 'GitHub' },
  { icon: <InstagramIcon />, label: 'Instagram' },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 6, px: { xs: 3, md: 8 },
        borderTop: '1px solid rgba(255,110,180,0.1)',
        background: 'rgba(13,10,18,0.95)',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(135deg, #ff6eb4, #b44fff)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                letterSpacing: 2,
                mb: 0.5,
              }}
            >
              ✦ panekopannko
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              swedish gremlin hacker — making &amp; breaking stuff
            </Typography>
          </Box>

          <Stack direction="row" spacing={1}>
            {socials.map((s) => (
              <IconButton
                key={s.label}
                aria-label={s.label}
                sx={{
                  color: 'text.secondary',
                  border: '1px solid rgba(255,110,180,0.15)',
                  '&:hover': {
                    color: 'primary.main',
                    borderColor: 'primary.main',
                    background: 'rgba(255,110,180,0.08)',
                  },
                }}
              >
                {s.icon}
              </IconButton>
            ))}
          </Stack>
        </Stack>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,110,180,0.08)' }} />

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.3)' }}>
            © 2026 panekopannko. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={3}>
            {['Privacy Policy', 'Terms', 'Contact'].map((link) => (
              <Typography
                key={link}
                variant="caption"
                sx={{
                  color: 'rgba(255,255,255,0.3)',
                  cursor: 'pointer',
                  '&:hover': { color: 'primary.main' },
                }}
              >
                {link}
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
